export class Document{
    s_ins: number;
    doc_desc: string;
    doc_url: string;

    constructor(){}
}